// extracted by mini-css-extract-plugin
export default {"select":"RCZ2T3Q0yEbG3AWmCm_X__select___"};